import { render, staticRenderFns } from "./wellInfo.vue?vue&type=template&id=38546064&scoped=true"
import script from "./wellInfo.vue?vue&type=script&lang=js"
export * from "./wellInfo.vue?vue&type=script&lang=js"
import style0 from "./wellInfo.vue?vue&type=style&index=0&id=38546064&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38546064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38546064')) {
      api.createRecord('38546064', component.options)
    } else {
      api.reload('38546064', component.options)
    }
    module.hot.accept("./wellInfo.vue?vue&type=template&id=38546064&scoped=true", function () {
      api.rerender('38546064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wellManage/myWells/wellInfo.vue"
export default component.exports